










































































































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { reduce } from 'lodash'
import { Col, DataTable } from '@/components/molecules/DataTable'
import { ReserveSpecifyBranchCode, Reserve, SystemCode } from '@/api'
import { ReserveStatus } from '@/types'
import { dataStore } from '@/utils/store-accessor'

@Component({
  components: {
    DataTable
  }
})
export default class ReserveListTable extends ComponentVue {
  @Prop({
    type: Array
  })
  items!: Reserve[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: String,
    required: true
  })
  editableUserId!: string

  @Prop({
    type: Boolean
  })
  dialog!: boolean

  get cols(): Col[] {
    const cols: Col[] = [
      {
        width: 30,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'userId',
            headerText: '予約利用者番号'
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        items: [
          {
            name: 'userName',
            headerText: '予約利用者'
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        items: [
          {
            name: 'reserveRegistrationTime',
            headerText: '予約日'
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        items: [
          {
            name: 'preferredDate',
            headerText: '受取希望日'
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        items: [
          {
            name: 'reserveExpiration',
            headerText: '受取待期限日'
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'reserveSpecifyBranchCodes',
            headerText: '特定館'
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'reserveRegistrationBranchCode',
            headerText: '予約館'
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'forwardingBranchCode',
            headerText: '回送館'
          }
        ]
      },
      {
        width: '7',
        resizable: true,
        items: [
          {
            name: 'specifyCollectionId',
            headerText: '種別'
          }
        ]
      },
      {
        width: '7',
        resizable: true,
        items: [
          {
            name: 'reserveStatus',
            headerText: '状態'
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'reserveNoticeAllowed',
            headerText: '通知'
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'displayMemo',
            headerText: 'メモ'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'contactMethod',
            headerText: '連絡方法'
          }
        ]
      },
      {
        width: 115,
        items: [
          {
            name: 'edit',
            align: 'center'
          }
        ]
      },
      {
        width: 30,
        items: [
          {
            name: 'remove',
            align: 'center'
          }
        ]
      }
    ]

    if (dataStore.displayModalReserveReserveUserNameColumn) {
      return cols
    }

    let userNameColumnWidth: string | number = cols[2].width

    cols.splice(2, 1)

    while (Number(userNameColumnWidth) > 0) {
      cols.forEach(col => {
        if (
          typeof col.width === 'number' ||
          Number(userNameColumnWidth) === 0
        ) {
          return
        }

        col.width = String(Number(col.width) + 1)
        userNameColumnWidth = String(Number(userNameColumnWidth) - 1)
      })
    }

    return cols
  }

  get canPrint() {
    return (reserveStatus: SystemCode) => {
      return (
        reserveStatus.code === ReserveStatus.ReceiveWaiting ||
        reserveStatus.code === ReserveStatus.Forwarding
      )
    }
  }

  @Emit('click:user-id')
  onClickLink() {}

  @Emit('preferred-date')
  onInputPreferredDate(date: string, index: number): any {
    return {
      date,
      index
    }
  }

  @Emit('reserve-expiration')
  onInputReserveExpiration(date: string, index: number): any {
    return {
      date,
      index
    }
  }

  @Emit('click:edit')
  onClickEdit() {}

  @Emit('click:remove')
  onClickRemove(id: number): number {
    return id
  }

  @Emit('click:print')
  onClickReceiptPrint(id: number): number {
    return id
  }

  existsDisplayMemo(memo: string | null): boolean {
    return !!memo
  }

  editableUser(value: string): boolean {
    if (this.editableUserId === '') {
      return true
    } else {
      return this.editableUserId === value
    }
  }

  shortNameOfReserveSpecifyBranchCode(
    array: ReserveSpecifyBranchCode[]
  ): string {
    return reduce(
      array,
      (accumulator: string, currentValue: ReserveSpecifyBranchCode, index) => {
        accumulator += currentValue.branchCode.shortName
        if (index === array.length - 1) return accumulator
        return accumulator + ','
      },
      ''
    )
  }
}
